import { render, staticRenderFns } from "./AddressColorCellRenderer.vue?vue&type=template&id=2208af40&scoped=true&lang=pug&"
import script from "./AddressColorCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./AddressColorCellRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./AddressColorCellRenderer.vue?vue&type=style&index=0&id=2208af40&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2208af40",
  null
  
)

export default component.exports